// Ported from NearpodNext's
// `src/components/activity_textarea/editor/rich_text_editor/richTextEditorContentTypes.js`.
//
// TTC question and answer text was plain text until the accessible-math work; the editor only
// emits rich text when the accessible-math-characters flag is on. A migrated field therefore holds
// either kind, and this marker is the only thing that tells them apart. Keep in sync with
// NearpodNext, which writes the marker.

export const CONTENT_TYPE_ATTRIBUTE_NAME = 'data-content-type'

const ContentType = {
	RICH_TEXT: 'rich-text',
}

const isRichTextContent = (content = ''): boolean =>
	content.includes(`${CONTENT_TYPE_ATTRIBUTE_NAME}="${ContentType.RICH_TEXT}"`)

const escapeHtml = (text: string): string =>
	text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

// Combines values that are each plain or rich text into one string for a single RichTextContent.
// The kinds cannot simply be concatenated: one rich-text piece makes the whole result parse as
// HTML, and a legacy plain answer like "3 < 5" would then lose everything from the "<" on. Escaping
// only happens in that case — with no rich-text piece the result stays plain and is never parsed,
// so escaping would surface entities literally.
export const joinRichTextContent = (pieces: string[], separator = ', '): string =>
	pieces.some(isRichTextContent)
		? pieces.map((piece) => (isRichTextContent(piece) ? piece : escapeHtml(piece))).join(separator)
		: pieces.join(separator)

export default isRichTextContent
